import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist'
import {
  ProductSKUTableSortProps,
  ProductSKUTableSearchProps
} from './products-skus-table-base.types'

export const initialProductSKUTablePaginationProps: PaginationProps<ProductSKUTableSortProps> = {
    page: 0,
    size: 100,
    sortDirection: SortDirection.ASC,
    sortProp: ProductSKUTableSortProps.SKU,
    totalElements: 0,
    totalPages: 0
}

export const initialProductSKUTableSearchProps: ProductSKUTableSearchProps = {
    status: null,
    name: null,
    minPrice: null,
    maxPrice: null,
    minStock: null,
    maxStock: null,
    minSold: null,
    maxSold: null,
    minRevenue: null
}

export const skusTableNeedTimeoutProps: Array<keyof ProductSKUTableSearchProps> = [
    "name"
]
